import { Permission, Role } from './types';

export interface ProjectAccessRoleCheck {
    actorRole: Role | null | undefined;
    targetRole: Role | null | undefined;
    isSuperAdmin?: boolean;
    isProjectOwner?: boolean;
}

export function roleHasProjectAdminAuthority(role: Role | null | undefined): boolean {
    if (!role) return false;
    return role.permissions.includes(Permission.MANAGE_PROJECT_OWNER)
        || role.permissions.includes(Permission.MANAGE_PROJECT_ADMINS);
}

export function canAssignProjectAccessRole({
    actorRole,
    targetRole,
    isSuperAdmin = false,
    isProjectOwner = false,
}: ProjectAccessRoleCheck): boolean {
    if (!targetRole || targetRole.permissions.includes(Permission.MANAGE_PROJECT_OWNER)) {
        return false;
    }

    if (isSuperAdmin || isProjectOwner) {
        return true;
    }

    if (!actorRole) {
        return false;
    }

    if (actorRole.permissions.includes(Permission.MANAGE_PROJECT_ADMINS)) {
        return true;
    }

    if (actorRole.permissions.includes(Permission.MANAGE_MEMBERS)) {
        return !roleHasProjectAdminAuthority(targetRole)
            && !targetRole.permissions.includes(Permission.MANAGE_MEMBERS);
    }

    return false;
}

export function canManageInviteForRole(check: ProjectAccessRoleCheck): boolean {
    return canAssignProjectAccessRole(check);
}
